import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './components/Pages/Home';
import Menu from './components/Pages/Menu';

function App() {
  return (
    <>
      <Router>
        <Navbar/>
        <Routes>
          <Route path="/" exact element={<Home/>}/>
          <Route path="/menu" element={<Menu/>}/>
        </Routes>
      </Router>
      
    </>
  );
}

export default App;
